import React, { Fragment, useContext } from 'react'
import {
    Grid,
    Popup,
    Statistic,
    Label,
    Button,
    Rating,
    Flag,
    Segment,
    Header,
} from 'semantic-ui-react'
import countries from '../../constants/countries.json'
import SocialIcon from '../Resources/SocialIcon'
import BlockExpertButton from './BlockExpertButton'
import DataContext from '../../contexts/DataContext'

const ExpertStatus = ({ expert, onSelect, selectedExperts }) => {
    const { user } = useContext(DataContext)
    return (
        <Fragment>
            <Grid.Row style={{ paddingBottom: 0 }}>
                <SocialIcon expert={expert} />
                <Popup
                    content={expert.expert.country}
                    trigger={
                        <Flag
                            style={{ marginTop: '7px' }}
                            name={countries[expert.expert.country]}
                        />
                    }
                />
                <br />
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: 0 }} columns={2}>
                <Fragment>
                    <Grid.Column width={10} style={{ paddingLeft: 0 }}>
                        {'Expert Status: '}
                        <Label
                            color={
                                expert.expert.status === 'Active' &&
                                !expert.expert.isBlocked
                                    ? 'green'
                                    : 'black'
                            }
                            style={{ marginLeft: '1%', marginRight: '1rem' }}
                        >
                            {expert.expert.isBlocked
                                ? 'Blocked'
                                : expert.expert.status}
                        </Label>
                        {user.isSuperUser() && (
                            <BlockExpertButton expert={expert} />
                        )}
                    </Grid.Column>
                    <Grid.Column width={6} floated="right">
                        <span style={{ float: 'right', marginLeft: '5px' }}>
                            {expert.expert.numRatings}
                        </span>{' '}
                        <Rating
                            icon="star"
                            rating={Math.round(expert.expert.avgRating) || 0}
                            maxRating={5}
                            style={{ float: 'right', marginTop: '5px' }}
                            disabled
                        />
                    </Grid.Column>
                </Fragment>
            </Grid.Row>
            {user.isSuperUser() && expert.expert.isBlocked && expert.expert.blockReason && (
                <Grid.Row>
                    <Grid.Column width={16} style={{ paddingLeft: 0 }}>
                        <Segment>
                            <Header as="h4">Reason for blocking</Header>
                            <p>{expert.expert.blockReason}</p>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            )}
            <Grid.Row columns={2}>
                
                <Grid.Column style={{ paddingLeft: 0 }}>
                    Stripe Status:
                    <span
                        style={{
                            color: expert.expert.stripeAccount.isConnected
                                ? 'green'
                                : 'red',
                            marginLeft: '1%',
                        }}
                    >
                        {expert.expert.stripeAccount.isConnected
                            ? 'Connected'
                            : 'Not Connected'}
                    </span>
                </Grid.Column>
                {window.location.pathname.includes('/experts') &&
                window.location.pathname.includes('/projects') ? (
                    <Grid.Column floated="right">
                        <Button
                            color="blue"
                            size="tiny"
                            basic={
                                !selectedExperts
                                    .map((expert) => expert.id)
                                    .includes(expert.id)
                            }
                            floated="right"
                            disabled={
                                expert.expert.status !== 'Active' ||
                                expert.expert.isBlocked
                            }
                            onClick={() => onSelect(expert)}
                        >
                            {selectedExperts
                                .map((expert) => expert.id)
                                .includes(expert.id)
                                ? 'Selected'
                                : 'Select'}
                        </Button>
                    </Grid.Column>
                ) : null}
            </Grid.Row>
            <Grid.Row>
                <Statistic.Group>
                    <Statistic horizontal>
                        <Statistic.Value>
                            {`$${expert.expert.hourlyRate}`}
                        </Statistic.Value>
                        <Statistic.Label>/ hr</Statistic.Label>
                    </Statistic>
                    <Statistic horizontal>
                        <Statistic.Value>
                            {expert.expert.responseRate || 0}%
                        </Statistic.Value>
                        <Statistic.Label>response rate</Statistic.Label>
                    </Statistic>
                    <Statistic horizontal>
                        <Statistic.Value>
                            {expert.expert.numCompleted || 0}
                        </Statistic.Value>
                        <Statistic.Label>completed engagements</Statistic.Label>
                    </Statistic>
                </Statistic.Group>
            </Grid.Row>
        </Fragment>
    )
}

export default ExpertStatus
